var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    ref: 'swatchesMain-' + _vm.groupName,
    class: ['swatches-view-swatches-wrapper', {
      'organism': _vm.configuration.enableAtomicSwatchTray
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$store.state.utils.trayDisabled.swatches,
      expression: "$store.state.utils.trayDisabled.swatches"
    }],
    staticClass: "disable-swatches"
  }), _c('div', {
    class: ['swatches-view-swatches-wrapper-container', {
      scrollActive: _vm.scrollActive
    }]
  }, [_c('div', {
    staticClass: "swatches-view-swatches-wrapper-container-scroll"
  }, [_vm.configuration.enableAtomicSwatchTray ? _c('Swatches', {
    attrs: {
      "activeGroup": _vm.activeGroup,
      "customStyle": {
        transform: "translate(".concat(this.scrollValue, "px, 0px)"),
        transition: "transform ".concat(this.scrollSpeed, "s ease 0s")
      },
      "groupName": _vm.groupName,
      "swatchesToRenderOrdered": _vm.swatchesToRenderOrdered
    }
  }) : _c('div', {
    ref: 'swatchesWrapper-' + _vm.groupName,
    class: ['swatches-view-swatches-wrapper-container-scroll-content', 'swatches-' + _vm.groupName + '-container', {
      swatchesContainerActive: _vm.activeGroup == _vm.groupName
    }],
    style: {
      transform: "translate(".concat(this.scrollValue, "px, 0px)"),
      transition: "transform ".concat(this.scrollSpeed, "s ease 0s")
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hasTitleProperties(_vm.groupName),
      expression: "hasTitleProperties(groupName)"
    }],
    staticClass: "swatches-view-swatches-wrapper-container-scroll-content is-group-title"
  }, [_c('div', {
    staticClass: "group-title"
  }, [_c('span', {
    staticClass: "group-text title"
  }, [_vm._v("\n              " + _vm._s(_vm.getTabData(_vm.groupName).title) + "\n            ")]), _c('span', {
    staticClass: "group-text subtitle"
  }, [_vm._v("\n              " + _vm._s(_vm.getTabData(_vm.groupName).subtitle) + "\n            ")])])]), _vm._l(_vm.swatchesToRenderOrdered, function (subgroups, index) {
    return _c('div', {
      key: subgroups.palette_id || subgroups.name,
      staticClass: "swatches-view-swatches-wrapper__swatches-container"
    }, [subgroups.swatches && subgroups.swatches.length || !_vm.configuration.enableCollapsingSwatches ? _c('keep-alive', {
      attrs: {
        "max": 10
      }
    }, [_c('swatches', {
      key: subgroups.palette_id || subgroups.name,
      attrs: {
        "swatchesArray": subgroups.swatches,
        "subgroup": subgroups,
        "groupName": _vm.groupName,
        "hasModal": _vm.hasModal(subgroups),
        "isFirstSubgroup": index === 0
      }
    })], 1) : _vm._e()], 1);
  })], 2)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.scrollActive,
      expression: "scrollActive"
    }],
    class: ['swatches-view-swatches-wrapper-container-navigation', {
      'organism': _vm.configuration.enableAtomicSwatchTray
    }, {
      scrollNavigationActive: _vm.activeGroup == _vm.groupName
    }]
  }, [_c('button', {
    class: ['swatches-view-swatches-wrapper-container-navigation-button clear button', {
      disabledScroll: _vm.disableLeftButton
    }],
    attrs: {
      "aria-label": "swatches navigation button left",
      "role": "button",
      "disabled": _vm.disableLeftButton
    },
    on: {
      "click": _vm.scrollLeft
    }
  }, [_c('span', {
    ref: "scrollOverLeft",
    staticClass: "icon-arrow-left-indicator"
  })]), _c('button', {
    class: ['swatches-view-swatches-wrapper-container-navigation-button clear button', {
      disabledScroll: _vm.disableRightButton
    }],
    attrs: {
      "aria-label": "swatches navigation button right",
      "role": "button",
      "disabled": _vm.disableRightButton
    },
    on: {
      "click": _vm.scrollRight
    }
  }, [_c('span', {
    ref: "scrollOverRight",
    staticClass: "icon-arrow-right-indicator"
  })])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }